import { largeTabletMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { MAX_WIDTH } from '../layout/PageWrapper.style';

export const AuctionsGrid = styled.div`
  max-width: ${MAX_WIDTH}px;
  margin: 40px auto;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-column-gap: 20px;
  grid-row-gap: 30px;
  grid-auto-flow: row dense;
  list-style: none;
  padding: 0 30px;

  @media (${largeTabletMax}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 15px;
  }

  @media (${mobileXXLargeMax}) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    padding: 15px;
  }
`;

export default AuctionsGrid;
